<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-truck"/> {{caption}}
        <div class="card-header-actions">
          <CButton color="info" size="sm" @click="storeModal()">Administrar</CButton>
          <CButton color="danger" size="sm" @click="clearProductsModal()">Limpiar</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="30"
        :dark="dark"
        pagination
      >
        <template #id="{item}"><td class="w100 text-center">{{item.id}}</td></template>
        <template #sat_code="{item}"><td class="w150 text-center">{{item.sat_code}}</td></template>
        <template #actions="{item}">
          <td class="table_actions b2">
            <CButton color="danger" size="sm" @click="deleteModal(item)"><CIcon name="cil-trash"/></CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <ProductModal ref="productModal" @store="storeProcess"></ProductModal>
    <ClearProductsModal ref="clearProductsModal" @delete="clearProductsProcess"></ClearProductsModal>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import ProductModal from './ProductModal.vue'
import DeleteModal from '../../global/DeleteModal.vue'
import ClearProductsModal from './ClearProductsModal.vue'
import ws from '../../../services/fiscal-products';
import store from '../../../store'

export default {
  name: 'ProductsTable',
  components: { ProductModal, DeleteModal, ClearProductsModal },
  props: {
    items: Array,
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      fields: [
        {key: 'sat_code', label: 'Código SAT'},
        {key: 'name', label: 'Nombre'},
        {key: 'actions', label: 'Acciones', class: 'actions' }
      ],
      toasts: []
    }
  },
  methods: {
    storeModal () {
      this.$refs.productModal.storeModal();
    },
    clearProductsModal (item) {
      this.$refs.clearProductsModal.show("Limpiar Productos", 0, "");
    },
    async clearProductsProcess(id) {
      let response = await ws.clearSelectedProducts();
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    deleteModal (item) {
      this.$refs.deleteModal.show("Eliminar Producto", item.sat_code, item.name);
    },
    async deleteProcess(code) {
      let response = await ws.deleteSelectedProduct(code);
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async storeProcess(data) {
      this.$emit("refresh", data );
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    },
  }
}
</script>
